<template>
  <svg
    width="6"
    height="4"
    viewBox="0 0 6 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.99998 4L3.49691e-07 -5.24537e-07L6 0L2.99998 4Z"
      fill="#DF252A"
    />
  </svg>
</template>
